import { AdminPageLayout } from "@/layouts/AdminPageLayout";
import React from "react";
import { OperationItem, OperationsList } from "./OperationsList";

const items: OperationItem[] = [
  {
    title: "Student Management",
    description:
      "Effortlessly manage student information, track progress, and oversee enrollment.",
    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800",
    route: "/admin/access/students",
  },
  {
    title: "Teacher Management",
    description:
      "Manage teacher profiles, schedules, and performance evaluations with ease.",
    image:
      "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=800",
    route: "/admin/access/teachers",
  },
  {
    title: "Special Access User Management",
    description:
      "Handle users with special access, customize permissions, and maintain security protocols.",
    image:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800",
    route: "/admin/access/users",
  },
];

const AdminAccessPage: React.FC = () => {
  return (
    <AdminPageLayout title="Manage Access">
      <OperationsList items={items} />
    </AdminPageLayout>
  );
};

export default AdminAccessPage;
